import request from '../../../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comLoginParnter/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const handleStatus = query => {  
    var list = request({
        url: 'comLoginParnter/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comLoginParnter/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comLoginParnter/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDeleteMore = query => {  
    var list = request({
        url: 'comLoginParnter/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comLoginParnter/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const fetchSelect = query => {  
    var list = request({
        url: 'comLoginParnter/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




